import { Navigate } from 'react-router-dom';
import { Center, Loader } from '@mantine/core';
import { useAuth } from '@/hooks';
import { AUTH_STATE, ROUTE_ALIASES } from '@/types';

export const AuthCallbackPage = () => {
  const { state } = useAuth();

  if (state === AUTH_STATE.AUTHENTICATED) {
    return <Navigate to={ROUTE_ALIASES.ORGANIZATIONS} replace />;
  }

  return (
    <Center h="100vh">
      <Loader size="lg" />
    </Center>
  );
};
